/**
 * Let the browser paint the wait cursor before a long task blocks the thread.
 * requestAnimationFrame schedules a frame; the timeout runs after that paint.
 */
export function yieldForPaint(): Promise<void> {
  return new Promise((resolve) => {
    const raf = globalThis.requestAnimationFrame;
    if (typeof raf !== "function") {
      setTimeout(resolve, 0);
      return;
    }
    raf(() => {
      setTimeout(resolve, 0);
    });
  });
}
